import RegisterPartner from './register-partner-container';

export default RegisterPartner;
